export default "<div class=\"info-box__text\">{{text}}</div>\n<div class=\"info-box__title\">{{title}}</div>"